"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synthesizePhysicalPartFromPins = synthesizePhysicalPartFromPins;
function synthesizePhysicalPartFromPins(libPart) {
    const normalView = libPart.NormalView?.[0];
    const pins = [...(normalView?.PinScalar ?? []), ...(normalView?.PinBus ?? [])];
    return {
        PinNumber: pins.map((pin) => ({
            Position: pin.Position,
            Number: pin.Name,
        })),
    };
}
//# sourceMappingURL=orcadDsnPhysicalPartFallback.js.map